import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class BeneficiaryCategory extends Enum {
  static ADULT = {
    key: 'adult',
    get value() {
      return Lang.t('beneficiary.adult');
    }
  };

  static CHILD = {
    key: 'child',
    get value() {
      return Lang.t('beneficiary.child');
    }
  };

  static ORGANIZATION = {
    key: 'organization',
    get value() {
      return Lang.t('beneficiary.organization');
    }
  };

  /**
   * @param key
   * @returns {*}
   */
  static isPerson(key) {
    return !this.isOrganization(key);
  }

  /**
   * @param key
   * @returns {boolean}
   */
  static isAdult(key) {
    return key === this.ADULT.key;
  }

  /**
   * @param key
   * @returns {boolean}
   */
  static isChild(key) {
    return key === this.CHILD.key;
  }

  /**
   * @param key
   * @returns {boolean}
   */
  static isOrganization(key) {
    return key === this.ORGANIZATION.key;
  }
}
